/**
 * Private event names
 */
export const EVENTS = {
	/**
	 * Private events used in MainContainer
	 */
	PRIVATE: {
		TO_HOST: 'message-to',
		FROM_HOST: 'message-from'
	},
	PUBLIC: {
		/**
		 * Send message from app to host
		 * Use only in host
		 * */
		TO_HOST: 'message',
		/**
		 * Send message from host to app
		 * Use only in app
		 * */
		FROM_HOST: 'message'
	}
};

/**
 * Event types
 */
export enum MESSAGE_TYPES {
	NAVIGATION = 'navigation',
	ANALYTICS = 'analytics',
	NOTIFICATION = 'notification',
	SHARE_COMPONENT = 'share-component'
}

// TODO Remove as unused
export const NAVIGATION_TYPES = {
	NAVIGATION_START: 'navigation-start',
	NAVIGATION_FINISH: 'navigation-finish'
};

export const ANALYTICS_TYPES = {
	GOOGLE_ANALYTICS: 'googleAnalytics'
};
